import React, { useCallback, useEffect, useState } from "react";
import $ from "jquery";
import { CUSTOMER_LOGO_SMALL } from "../constants/images";
import { Collective } from "../types/Collective";
import { NavLink, useLocation } from "react-router-dom";
import { Member } from "../types/Member";

declare global {
  interface Window {
    activeFeatures?: string[];
    isSuperofficeUser?: boolean;
  }
}

type Props = {
  loggedOut?: boolean;
  currentYear: number;
  currentCollective: string;
  currentUsername: string;
  allYears: number[];
  allCollectives: Collective[];
  allMembers: Member[];
  onToggleHelp: () => any;
};
export default function Header({
  loggedOut,
  currentCollective,
  currentYear,
  currentUsername,
  allYears,
  allCollectives,
  allMembers,
  onToggleHelp,
}: Props) {
  const location = useLocation();
  const currentPage = location.pathname.split("/")[1];
  const [dropdownToggled, toggleDropDown] = useState(false);
  const [menuToggled, toggleMenu] = useState(false);
  const activeMember = allMembers?.find(({ so_id }) => so_id === window.soId);

  useEffect(() => {
    return () => {
      toggleDropDown(false);
      toggleMenu(false);
    };
  }, [location.pathname]);

  const handleChangeYear = useCallback(
    (year) => {
      window.location.href = `/${year}/${currentCollective}/${currentPage}`;
    },
    [currentCollective, currentPage]
  );

  const handleChangeCollective = useCallback(
    (collectiveGid) => {
      window.location.href = `/${currentYear}/${collectiveGid}/${currentPage}`;
    },
    [currentYear, currentPage]
  );

  const handleChangeMember = useCallback(
    (soId) => {
      window.location.href = `/o/login_scan/?so_id=${soId}`; // TODO: change URL
    },
    [currentYear, currentPage]
  );

  const handleToggleCustomHelp = () => {
    $(".c-alert-wrapper").toggleClass("c-alert-wrapper--hidden");
  };

  useEffect(() => {
    if (menuToggled) toggleDropDown(false);
  }, [menuToggled]);
  useEffect(() => {
    if (dropdownToggled) toggleMenu(false);
  }, [dropdownToggled]);

  // toggle mobile navigation mode
  useEffect(() => {
    document.body.classList.toggle("c-navigation-mobile--is-open", menuToggled && !dropdownToggled);
  }, [menuToggled, dropdownToggled]);

  if (loggedOut) {
    return (
      <nav className="c-navigation">
        <a className="c-navigation__logo" href="/">
          <div className="c-navigation__logo">
            <img src={CUSTOMER_LOGO_SMALL} alt="Logo Boerennatuur" width="32px" height="32px" />
          </div>
        </a>
        <div className="c-navigation__user c-navigation__user--ope">
          <a className="c-navigation__help" onClick={handleToggleCustomHelp}>
            <svg className="c-icon c-icon--size-m c-navigation__help__icon">
              <use xlinkHref="#icon-chat" />
            </svg>
            Help
          </a>
        </div>
      </nav>
    );
  }

  return (
    <nav className="c-navigation">
      <div className="c-navigation__selects">
        {allCollectives.length > 0 ? (
          <div className="c-form-select c-form-select--transparent c-navigation__select">
            <select
              name="gidselect"
              id="gidselect"
              value={currentCollective}
              onChange={(event) => handleChangeCollective(event.target.value)}
            >
              {allCollectives.map((collective) => (
                <option key={collective.gid} value={collective.gid}>
                  {collective.name}
                </option>
              ))}
            </select>
          </div>
        ) : null}

        {allMembers.length > 0 ? (
          <div className="c-form-select c-form-select--transparent c-navigation__select">
            <select
              name="memberselect"
              id="memberselect"
              value={`${activeMember?.so_id}`}
              onChange={(event) => handleChangeMember(event.target.value)}
            >
              {allMembers.map((member) => (
                <option key={member.so_id} value={member.so_id}>
                  {member.collective_name} - {member.name}
                </option>
              ))}
            </select>
          </div>
        ) : null}
        {allMembers.length > 0 || allCollectives.length > 0 ? (
          <div className="c-form-select c-form-select--transparent c-navigation__select">
            <select
              name="yearselect"
              id="yearselect"
              value={`${currentYear}`}
              onChange={(event) => handleChangeYear(event.target.value)}
            >
              {allYears.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        ) : null}
      </div>

      {allMembers.length > 0 || allCollectives.length > 0 ? (
        <ul className="c-navigation__list">
          <li className="c-navigation__item">
            <NavLink
              to="/home/"
              className={(isActive) => "c-navigation__link" + (isActive ? " active" : "")}
            >
              Home
            </NavLink>
          </li>
          <li className="c-navigation__item">
            <NavLink
              to="/kaart/"
              className={(isActive) => "c-navigation__link" + (isActive ? " active" : "")}
            >
              Kaart
            </NavLink>
          </li>
          <li className="c-navigation__item">
            <NavLink
              to="/percelen/"
              className={(isActive) => "c-navigation__link" + (isActive ? " active" : "")}
            >
              Percelen
            </NavLink>
          </li>
          <li className="c-navigation__item">
            <NavLink
              to="/meldingen/"
              className={(isActive) => "c-navigation__link" + (isActive ? " active" : "")}
            >
              Meldingen
            </NavLink>
          </li>
          {window.kpisEnabled ? (
            <li className="c-navigation__item">
              <NavLink
                to="/kpis/"
                className={(isActive) => "c-navigation__link" + (isActive ? " active" : "")}
              >
                KPI's
              </NavLink>
            </li>
          ) : null}
          {window.kpiAuthorizationsAvailable ? (
            <li className="c-navigation__item">
              <NavLink
                to="/machtigingen/"
                className={(isActive) => "c-navigation__link" + (isActive ? " active" : "")}
              >
                Machtigingen
              </NavLink>
            </li>
          ) : null}
          <li className="c-navigation__item">
            <NavLink
              to="/documenten/"
              className={(isActive) => "c-navigation__link" + (isActive ? " active" : "")}
            >
              Documenten
            </NavLink>
          </li>
          <li className="c-navigation__item">
            <NavLink
              to="/contact/"
              className={(isActive) => "c-navigation__link" + (isActive ? " active" : "")}
            >
              Contact
            </NavLink>
          </li>
        </ul>
      ) : null}

      <div className={`c-navigation__user ${dropdownToggled ? "c-navigation__user--open" : ""}`}>
        {allMembers.length > 0 || allCollectives.length > 0 ? (
          <a className="c-navigation__help" onClick={onToggleHelp}>
            <svg className="c-icon c-icon--size-m c-navigation__help__icon">
              <use xlinkHref="#icon-chat" />
            </svg>
            Help
          </a>
        ) : null}
        <a className="c-navigation__user-name" onClick={() => toggleDropDown(!dropdownToggled)}>
          {currentUsername}
        </a>
        <ul className="c-account">
          {allMembers.length > 0 || allCollectives.length > 0 ? (
            <>
              <li className="c-account__item">
                <NavLink
                  to="/account/"
                  className={(isActive) => "c-account__link" + (isActive ? " active" : "")}
                >
                  Account
                </NavLink>
              </li>
              <li className="c-account__item">
                <NavLink
                  to="/gegevens/"
                  className={(isActive) => "c-account__link" + (isActive ? " active" : "")}
                >
                  Mijn gegevens
                </NavLink>
              </li>
            </>
          ) : null}
          <li className="c-account__item">
            <a className="c-account__link" href="/logout/">
              Uitloggen
            </a>
          </li>
        </ul>
      </div>

      <div className="c-navigation-mobile">
        <a className="c-navigation-mobile__toggle" onClick={() => toggleMenu(!menuToggled)}>
          Menu
        </a>
        <ul className="c-navigation-mobile__list">
          <li className="c-navigation-mobile__item">
            <NavLink
              to="/home/"
              className={(isActive) => "c-navigation-mobile__link" + (isActive ? " active" : "")}
            >
              Home
            </NavLink>
          </li>
          <li className="c-navigation-mobile__item">
            <NavLink
              to="/kaart/"
              className={(isActive) => "c-navigation-mobile__link" + (isActive ? " active" : "")}
            >
              Kaart
            </NavLink>
          </li>
          <li className="c-navigation-mobile__item">
            <NavLink
              to="/percelen/"
              className={(isActive) => "c-navigation-mobile__link" + (isActive ? " active" : "")}
            >
              Percelen
            </NavLink>
          </li>
          <li className="c-navigation-mobile__item">
            <NavLink
              to="/meldingen/"
              className={(isActive) => "c-navigation-mobile__link" + (isActive ? " active" : "")}
            >
              Meldingen
            </NavLink>
          </li>
          {window.kpisEnabled ? (
            <li className="c-navigation-mobile__item">
              <NavLink
                to="/kpis/"
                className={(isActive) => "c-navigation-mobile__link" + (isActive ? " active" : "")}
              >
                KPI's
              </NavLink>
            </li>
          ) : null}
          {window.kpiAuthorizationsAvailable ? (
            <li className="c-navigation-mobile__item">
              <NavLink
                to="/machtigingen/"
                className={(isActive) => "c-navigation-mobile__link" + (isActive ? " active" : "")}
              >
                Machtigingen
              </NavLink>
            </li>
          ) : null}
          <li className="c-navigation-mobile__item">
            <NavLink
              to="/documenten/"
              className={(isActive) => "c-navigation-mobile__link" + (isActive ? " active" : "")}
            >
              Documenten
            </NavLink>
          </li>
          <li className="c-navigation-mobile__item">
            <NavLink
              to="/contact/"
              className={(isActive) => "c-navigation-mobile__link" + (isActive ? " active" : "")}
            >
              Contact
            </NavLink>
          </li>
          <li className="c-navigation-mobile__item">
            <NavLink
              to="/gegevens/"
              className={(isActive) => "c-navigation-mobile__link" + (isActive ? " active" : "")}
            >
              Mijn gegevens
            </NavLink>
          </li>
          <li className="c-navigation-mobile__item">
            <a className="c-navigation-mobile__link" href="/logout/">
              Uitloggen
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}
